import * as PIXI from "pixi.js";
import { LINE_CAP, LINE_JOIN } from "pixi.js";
import { RawPolygonWithHoles } from "@context/map/fields/fieldsStore";
import { hex2number } from "@utils/getColorByStatusUnit";
import { OverlaySetting } from "../LeafletPixiOverlayService";
import Logger from "@utils/logger";

const log = Logger.getLogger("polygon.drawer")
export type PolyDrawOptions = {
    alpha?: number,
    fillColor?: number
    lineColor?: number
    lineThickness?: number
}
export default function (container: PIXI.Graphics, settings: OverlaySetting, {
    alpha = 1,
    fillColor = hex2number("000000"),
    lineColor = hex2number("000000"),
    lineThickness = 10
}: PolyDrawOptions = {}) {
    let { project, scale = 1 } = settings;
    return function ([poly, ...holes]: RawPolygonWithHoles) {
        try {
            const shape = new PIXI.Polygon(poly.map(function (point) {
                return project([point[1], point[0]]);
            }));
            container.beginFill(fillColor, alpha);
            container.lineStyle({
                width: lineThickness / 100,
                color: lineColor,
                alpha: 1,
                cap: LINE_CAP.ROUND,
                join: LINE_JOIN.MITER
            });
            container.drawShape(shape);
            holes.forEach(hole => {
                container.beginHole();
                const shape = new PIXI.Polygon(hole.map(function (point) {
                    const proj = project([point[1], point[0]]);
                    return new PIXI.Point(proj.x, proj.y);
                }));
                container.drawShape(shape)
                container.endHole()
            })
        } catch (e) {
            log.error("An error occurred while drawing polygon...", [poly, ...holes], e)
        }
    };

}